"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRecommendedFasteners = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectRecommendedFasteners = (0, reselect_1.createSelector)((state) => state.recommendedFasteners, (recommendedFasteners) => recommendedFasteners);
